import React, { useState } from 'react';
import './Investment.css';

const Investment = () => {
  const [activeTab, setActiveTab] = useState('stocks');
  const [investmentAmount, setInvestmentAmount] = useState(1000);

  const investmentOptions = {
    stocks: [
      { id: 1, name: 'Tech Growth Fund', return: 12.5, risk: 'Medium', min: 500 },
      { id: 2, name: 'Global Index ETF', return: 8.2, risk: 'Low', min: 250 },
      { id: 3, name: 'AI Innovation Stocks', return: 18.7, risk: 'High', min: 1000 }
    ],
    crypto: [
      { id: 1, name: 'Bitcoin Trust', return: 22.3, risk: 'High', min: 100 },
      { id: 2, name: 'Ethereum Fund', return: 16.8, risk: 'High', min: 100 },
      { id: 3, name: 'Crypto Index', return: 14.5, risk: 'Medium', min: 500 }
    ],
    realEstate: [
      { id: 1, name: 'REIT Income Fund', return: 7.2, risk: 'Low', min: 1000 },
      { id: 2, name: 'Commercial Property', return: 9.1, risk: 'Medium', min: 5000 },
      { id: 3, name: 'Residential REIT', return: 6.8, risk: 'Low', min: 1000 }
    ]
  };

  const portfolio = [
    { id: 1, name: 'Tech Growth Fund', value: 4500, return: 12.5, change: '+2.3%' },
    { id: 2, name: 'REIT Income Fund', value: 3200, return: 7.2, change: '+0.8%' },
    { id: 3, name: 'Global Index ETF', value: 2800, return: 8.2, change: '+1.2%' }
  ];

  const totalPortfolioValue = portfolio.reduce((total, item) => total + item.value, 0);

  return (
    <div className="investments-container">
      <header className="investments-header">
        <h1>Investments</h1>
        <p>Grow your wealth with smart investment choices</p>
      </header>

      <div className="portfolio-summary">
        <div className="portfolio-card">
          <h3>Portfolio Value</h3>
          <div className="portfolio-value">${totalPortfolioValue.toLocaleString()}</div>
          <div className="portfolio-change">+2.1% today</div>
        </div>
        
        <div className="portfolio-stats">
          <div className="stat">
            <span className="stat-label">Total Return</span>
            <span className="stat-value">+$1,245.80</span>
          </div>
          <div className="stat">
            <span className="stat-label">Invested</span>
            <span className="stat-value">${(totalPortfolioValue - 1245.80).toLocaleString()}</span>
          </div>
          <div className="stat">
            <span className="stat-label">Annual Yield</span>
            <span className="stat-value">9.4%</span>
          </div>
        </div>
      </div>

      <div className="investment-section">
        <div className="section-header">
          <h2>Your Portfolio</h2>
          <button className="view-all-btn">View All</button>
        </div>
        
        <div className="portfolio-items">
          {portfolio.map(item => (
            <div key={item.id} className="portfolio-item">
              <div className="item-info">
                <h4>{item.name}</h4>
                <p>Annual return: {item.return}%</p>
              </div>
              <div className="item-values">
                <div className="item-value">${item.value.toLocaleString()}</div>
                <div className="item-change">{item.change}</div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="investment-section">
        <div className="section-header">
          <h2>Discover Investments</h2>
        </div>
        
        <div className="investment-tabs">
          <button 
            className={activeTab === 'stocks' ? 'tab active' : 'tab'} 
            onClick={() => setActiveTab('stocks')}
          >
            Stocks
          </button>
          <button 
            className={activeTab === 'crypto' ? 'tab active' : 'tab'} 
            onClick={() => setActiveTab('crypto')}
          >
            Crypto
          </button>
          <button 
            className={activeTab === 'realEstate' ? 'tab active' : 'tab'} 
            onClick={() => setActiveTab('realEstate')}
          >
            Real Estate
          </button>
        </div>
        
        <div className="investment-options">
          {investmentOptions[activeTab].map(option => (
            <div key={option.id} className="investment-card">
              <div className="investment-info">
                <h3>{option.name}</h3>
                <div className="investment-details">
                  <div className="detail">
                    <span className="label">Annual Return</span>
                    <span className="value highlight">{option.return}%</span>
                  </div>
                  <div className="detail">
                    <span className="label">Risk Level</span>
                    <span className={`value risk-${option.risk.toLowerCase()}`}>
                      {option.risk}
                    </span>
                  </div>
                  <div className="detail">
                    <span className="label">Minimum</span>
                    <span className="value">${option.min}</span>
                  </div>
                </div>
              </div>
              <div className="investment-action">
                <button className="invest-btn">Invest Now</button>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="investment-calculator">
        <h2>Investment Calculator</h2>
        <div className="calculator-container">
          <div className="calculator-input">
            <label>Investment Amount</label>
            <div className="amount-slider">
              <input 
                type="range" 
                min="100" 
                max="10000" 
                step="100"
                value={investmentAmount}
                onChange={(e) => setInvestmentAmount(e.target.value)}
              />
              <div className="amount-value">${investmentAmount}</div>
            </div>
            
            <div className="calculator-results">
              <div className="result">
                <span>1 Year Potential</span>
                <span>${(investmentAmount * 1.09).toLocaleString()}</span>
              </div>
              <div className="result">
                <span>5 Year Potential</span>
                <span>${(investmentAmount * 1.09 ** 5).toLocaleString()}</span>
              </div>
              <div className="result">
                <span>10 Year Potential</span>
                <span>${(investmentAmount * 1.09 ** 10).toLocaleString()}</span>
              </div>
            </div>
          </div>
          <div className="calculator-chart">
            <div className="chart-placeholder">
              <p>Growth Projection</p>
              <div className="chart-bar" style={{height: '60%'}}>
                <span>10 yr</span>
              </div>
              <div className="chart-bar" style={{height: '40%'}}>
                <span>5 yr</span>
              </div>
              <div className="chart-bar" style={{height: '20%'}}>
                <span>1 yr</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Investment;